import React, {useState, useRef, useEffect} from "react";
import classes from './SliderProgressBar.module.sass'
import monetinaTriste from './assets/monetina-triste.png'

function SliderProgressBar(props){
  const {
    progressBarBackgroundColor,
    score,
    sessionId,
    statusSlider
  } = props

  const boxRef = useRef();

  const animateRunner = () => {
    const speed = 3;
    TweenLite.to(boxRef.current, speed, {
      left: '70%',
      ease: Power1.easeInOut,
      onComplete: () => {
        TweenLite.to(boxRef.current, speed, {
          left: '-30px',
          ease: Power1.easeInOut,
          onComplete: () => {
            animateRunner(boxRef);
          }
        })
      }
    })
  }

  useEffect(() => {
    if(statusSlider=="loading") {
      animateRunner()
    }
  });

  const loaderClasses = () => {
    if(statusSlider=="loading"){
      return `${classes.monetina} ${sessionId}`
    } else {
      return `d-none ${classes.monetina} ${sessionId}`
    }
  }

  return (
    <div>
      <img src={monetinaTriste}
           ref={boxRef}
           className={loaderClasses()} />

      <div className={`progress ${sessionId}`} >
        <div className={`progress-bar ${classes.customBackground}`}
             role="progressbar"
             style={{width: score+'%', backgroundColor: progressBarBackgroundColor}}
             aria-valuenow={score}
             aria-valuemin="0"
             aria-valuemax="100" />
      </div>
    </div>)
}

export default SliderProgressBar